<template>
  <v-dialog v-model="add_modal" max-width="900" persistent>
    <v-card :loading="loading">
      <v-card-title>Add Customer</v-card-title>
      <v-card-text>
        <v-form>
          <v-row dense class="mb-0">
            <v-col cols="2">
              <v-text-field
                label="First"
                dense=""
                autofocus=""
                class="capitalize-first-letter"
                v-model="form_data.first_name"
                :error-messages="form_error.first_name"
                :hide-details="!form_error.first_name"
              ></v-text-field>
            </v-col>
            <v-col cols="1">
              <v-text-field
                label="M.I"
                dense=""
                v-model="form_data.middle_name"
                class="capitalize-first-letter"
                :error-messages="form_error.middle_name"
                :hide-details="!form_error.middle_name"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                label="Last"
                dense=""
                v-model="form_data.last_name"
                class="capitalize-first-letter"
                :error-messages="form_error.last_name"
                :hide-details="!form_error.last_name"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <v-text-field
                label="Short Code"
                v-mask="'XXXXXXX'"
                class="capitalize-whole-letter"
                v-model="form_data.short_code"
                :error-messages="form_error.short_code"
                :hide-details="!form_error.short_code"
                dense=""
              ></v-text-field>
            </v-col>
            <v-col class="d-flex justify-end">
              <v-switch
                v-model="form_data.bill_to_company"
                label="Bill To Company"
                color="success"
                hide-details
                class="mt-2"
                dense
              ></v-switch>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="2">
              <v-autocomplete
                label="Zip"
                dense=""
                v-model="form_data.zip"
                :error-messages="form_error.zip"
                :search-input.sync="zip_search"
                :items="zip_items"
                :hide-details="!form_error.zip"
                v-debounce:500="fetchZipCodes"
                :loading="zip_loading"
                autocomplete="off"
                :menu-props="{closeOnContentClick:true}"
              >
                <template v-slot:no-data v-if="zip_search">
                  <div class="d-flex align-center"><span class="pl-2" style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;">No Zip Found!</span> <span @click="addZip" class="mdi mdi-plus-circle pl-1 pr-2" style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"></span></div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1">
              <v-select
                :items="state_list"
                label="State"
                dense=""
                v-model="form_data.state_id"
                @change="getCity()"
                hide-details
              >
                <template v-slot:selection="{ item }">
                  <span>{{ item.short_name }}</span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                :items="cities"
                label="City"
                dense=""
                v-model="form_data.city"
                class="capitalize-first-letter"
                @change="changeCity()"
                :search-input.sync="city_search"
                hide-details=""
                :menu-props="{closeOnContentClick:true}"
              >
                <template v-slot:no-data v-if="city_search">
                  <div class="d-flex align-center"><span class="pl-2" style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;">No City Found!</span> <span @click="addCity" class="mdi mdi-plus-circle pl-1 pr-2" style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"></span></div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <v-text-field
                label="Mobile"
                dense=""
                v-model="form_data.mobile_number"
                :error-messages="form_error.mobile_number"
                :hide-details="!form_error.mobile_number"
                v-mask="'(###)-###-####'"
              ></v-text-field>
            </v-col>
            <v-col class="d-flex justify-end">
              <v-switch
                v-model="form_data.active"
                label="Active"
                color="success"
                hide-details
                class="mt-2"
                dense
              ></v-switch>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="6">
              <v-text-field
                label="Street Address"
                dense=""
                class="capitalize-first-letter"
                v-model="form_data.address_line_1"
                :error-messages="form_error.address_line_1"
                :hide-details="!form_error.address_line_1"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <v-text-field
                label="Office"
                dense=""
                v-mask="'(###)-###-####'"
                v-model="form_data.work_phone"
                :error-messages="form_error.work_phone"
                :hide-details="!form_error.work_phone"
              ></v-text-field>
            </v-col>
            <v-col class="d-flex justify-end">
              <v-switch
                v-model="form_data.email_alert"
                label="Email Alert"
                color="success"
                hide-details
                class="mt-2"
                dense
              ></v-switch>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="6">
              <v-text-field
                label="Street Address"
                class="capitalize-first-letter"
                dense=""
                v-model="form_data.address_line_2"
                :error-messages="form_error.address_line_2"
                :hide-details="!form_error.address_line_2"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <v-text-field
                label="Fax"
                dense=""
                v-mask="'(###)-###-####'"
                v-model="form_data.fax"
                :error-messages="form_error.fax"
                :hide-details="!form_error.fax"
              ></v-text-field>
            </v-col>
            <v-col cols="1"></v-col>
            <v-col class="d-flex justify-end">
              <v-text-field
                dense
                v-model="form_data.multiplier"
                :error-messages="form_error.multiplier"
                :hide-details="!form_error.multiplier"
                label="Multiplier "
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense class="mt-1">
            <v-col cols="6">
              <v-text-field
                label="Company Name"
                dense=""
                :disabled="!form_data.bill_to_company"
                v-model="form_data.company_name"
                :error-messages="form_error.company_name"
                :hide-details="!form_error.company_name"
                loading
              >
                <template v-slot:progress>
                  <v-progress-linear
                    value="100"
                    absolute
                    height="2"
                    class="primary"
                  ></v-progress-linear>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <v-text-field
                label="Email"
                dense=""
                v-model="form_data.email"
                :error-messages="form_error.email"
                :hide-details="!form_error.email"
                reverse
              ></v-text-field>
            </v-col>
            <v-col class="d-flex justify-end">
              <v-autocomplete
                :items="domain_list"
                label="Domain"
                dense=""
                prepend-icon="mdi-at"
                v-model="form_data.email_domain"
                :error-messages="form_error.email_domain"
                :hide-details="!form_error.email_domain"
                :search-input.sync="domain_search"
                :menu-props="{closeOnContentClick:true}"
              >
                <template v-slot:no-data>
                  <div class="d-flex align-center"><span class="pl-2" style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;">No Domain Found!</span> <span @click="addDomain" class="mdi mdi-plus-circle pl-1 pr-2" style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"></span></div>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="2">
              <v-autocomplete
                label="Zip"
                :disabled="!form_data.bill_to_company"
                dense=""
                v-model="form_data.comp_zip"
                :error-messages="form_error.comp_zip"
                :search-input.sync="comp_zip_search"
                :items="comp_zip_items"
                :hide-details="!form_error.comp_zip"
                v-debounce:500="fetchCZipCodes"
                :loading="comp_zip_loading"
                :menu-props="{closeOnContentClick:true}"
              >
                <template v-slot:no-data v-if="comp_zip_search">
                  <div class="d-flex align-center"><span class="pl-2" style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;">No Zip Found!</span> <span @click="addZip2" class="mdi mdi-plus-circle pl-1 pr-2" style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"></span></div>
                </template>
                <template v-slot:prepend>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-simple-checkbox
                          v-model="is_same_address"
                          :disabled="!form_data.bill_to_company"
                          :ripple="false"
                          @input="sameAddress()"
                        ></v-simple-checkbox>
                      </div>
                    </template>
                    <span>Same as above address</span>
                  </v-tooltip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1">
              <v-select
                :items="state_list"
                label="State"
                :disabled="!form_data.bill_to_company"
                dense=""
                v-model="form_data.comp_state_id"
                @change="getCity(true)"
                :hide-details="!form_error.comp_state_id"
              >
                <template v-slot:selection="{ item }">
                  <span>{{ item.short_name }}</span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                :items="company_cities"
                label="City"
                :disabled="!form_data.bill_to_company"
                dense=""
                v-model="form_data.comp_city"
                class="capitalize-first-letter"
                @change="changeCity2()"
                :hide-details="!form_error.comp_city"
              :search-input.sync="comp_city_search"
              :menu-props="{closeOnContentClick:true}"
              >
                <template v-slot:no-data v-if="comp_city_search">
                  <div class="d-flex align-center"><span class="pl-2" style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;">No City Found!</span> <span @click="addCity2" class="mdi mdi-plus-circle pl-1 pr-2" style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"></span></div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              
            </v-col>
          </v-row>
          <v-row dense class="mt-1">
            <v-col cols="6">
              <v-text-field
                label="Street Address"
                class="capitalize-first-letter"
                :disabled="!form_data.bill_to_company"
                dense=""
                v-model="form_data.comp_address_line_1"
                :error-messages="form_error.comp_address_line_1"
                :hide-details="!form_error.comp_address_line_1"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <!-- <v-btn block small class="grey lighten-1 text-capitalize">Total Orders: 456</v-btn> -->
              <v-card 
              class="pa-0 ma-0"
              rounded="0"
              flat>
                <v-card-subtitle class="custome-label-font pa-0 ma-0 pl-1">
                  Total Orders
                </v-card-subtitle>
                <v-card-text class="grey text-center lighten-1 custome-value-font pa-0 ma-0 pt-1 pb-1 pl-1">
                  <p class="mb-3"></p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="6">
              <v-text-field
                label="Street Address"
                class="capitalize-first-letter"
                :disabled="!form_data.bill_to_company"
                dense=""
                v-model="form_data.comp_address_line_2"
                :error-messages="form_error.comp_address_line_2"
                :hide-details="!form_error.comp_address_line_2"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <!-- <v-btn block small class="grey lighten-1 text-capitalize">Total Estimate: 456</v-btn> -->
              <v-card 
              class="pa-0 ma-0"
              rounded="0"
              flat>
                <v-card-subtitle class="custome-label-font pa-0 ma-0 pl-1">
                  Total Estimate
                </v-card-subtitle>
                <v-card-text class="grey text-center lighten-1 custome-value-font pa-0 ma-0 pt-1 pb-1 pl-1">
                  <p class="mb-3"></p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="2">
              <v-text-field
                label="Tax-ID"
                dense=""
                v-model="form_data.tax_id"
                :error-messages="form_error.tax_id"
                :hide-details="!form_error.tax_id"
                v-mask="'##-########'"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2"></v-col>
            <v-col cols="2">
              <!-- <v-btn block small class="error text-capitalize pa-0 ma-0">Ledger Balance: $12345.00</v-btn> -->
              <v-card 
              class="pa-0 ma-0"
              rounded="0"
              flat>
                <v-card-subtitle class="custome-label-font pa-0 ma-0 pl-1">
                  Ledger Balance
                </v-card-subtitle>
                <v-card-text class="error text-center white--text custome-value-font pa-0 ma-0 pt-1 pb-1 pl-1">
                  <p class="mb-3"></p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="error" @click="closePopup()" :disabled="loading">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn  color="primary" @click="saveCustomer()" :loading="loading">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState,mapMutations } from "vuex";
import axios from "../../plugins/axios";
import { FLORIDA_STATE } from '../../plugins/global_names';
export default {
  name: "AddCustomer",
  data: () => ({
    loading: false,
    form_data: {
      bill_to_company: false,
      text_alert: false,
      email_alert: false,
      active: true,
      zip : "",
      state_id : FLORIDA_STATE,
      comp_state_id : FLORIDA_STATE,
      multiplier: '1.00',
      address_line_1: null,
      address_line_2: null,
      comp_address_line_1: null,
      comp_address_line_2: null
    },
    is_same_address: false,
    comp_city_search: null,
    city_search: null,
    form_error: {},
    state_list: [],
    company_cities: [],
    cities: [],
    domain_list: [],
    zip_search: null,
    zip_loading: false,
    zip_items: [],
    new_zip_id: null,
    new_zip_id2: null,
    comp_zip_search: null,
    domain_search: null,
    comp_zip_items: [],
    comp_zip_loading: false,
  }),
  watch: {
    add_modal: {
      handler(val) {
        if (val) {
          this.form_data = {
            bill_to_company: false,
            text_alert: false,
            email_alert: false,
            active: true,
            zip : "",
            state_id : FLORIDA_STATE,
            comp_state_id : FLORIDA_STATE,
            multiplier: '1.00',
            address_line_1: null,
            address_line_2: null,
            comp_address_line_1: null,
            comp_address_line_2: null
          }
        }
      },
    },
    "form_data.zip": {
      handler() {
        this.getStates(false);
      },
    },
    "form_data.comp_zip": {
      handler() {
        this.getStates(true);
      },
    },
  },
  computed: {
    ...mapState("customer", ["add_modal"])
  },
  methods: {
    ...mapMutations("customer",['setData']),
    sameAddress() {
      if(this.is_same_address) {
        this.loading = true
        this.form_data.comp_address_line_1 = this.form_data.address_line_1
        this.form_data.comp_address_line_2 = this.form_data.address_line_2
        this.comp_zip_items = this.zip_items
        this.company_cities = this.cities
        this.form_data.comp_zip = this.form_data.zip
        this.form_data.comp_state_id = this.form_data.state_id
        this.form_data.comp_city = this.form_data.city
        this.loading = false
      }
    },
    addCity() {
      this.loading = true;
      let _self = this;
      axios
        .post("add_city", {state_id: _self.form_data.state_id,city_name: _self.city_search})
        .then(function (res) {
          let data = res.data.data;
           _self.cities.push({value: data.value,text: data.text});
          _self.form_data.city = data.value
          _self.changeCity()
          _self.loading = false;
        })
        .catch(function (error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    addCity2() {
      this.loading = true;
      let _self = this;
      axios
        .post("add_city", {state_id: _self.form_data.comp_state_id,city_name: _self.comp_city_search})
        .then(function (res) {
          let data = res.data.data;
           _self.company_cities.push({value: data.value,text: data.text});
          _self.form_data.comp_city = data.value
          _self.changeCity2()
          _self.loading = false;
        })
        .catch(function (error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    addDomain() {
      this.loading = true;
      let _self = this;
      axios
        .post("add_domain", { domain: _self.domain_search })
        .then(function (res) {
          let data = res.data.data;
          _self.domain_list.push({ value: data.domain_id, text: data.domain });
          _self.form_data.email_domain = data.domain_id;
          _self.loading = false;
        })
        .catch(function (error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    addZip() {
      this.loading = true;
      let _self = this;
      axios
        .post("add_zip", { zip_code: _self.zip_search })
        .then(function (res) {
          let data = res.data.data;
          _self.zip_items.push({ value: data.value, text: data.text });
          _self.form_data.zip = data.value;
          _self.new_zip_id = data.value;
          _self.getStates(false);
          _self.loading = false;
        })
        .catch(function (error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    addZip2() {
      this.loading = true;
      let _self = this;
      axios
        .post("add_zip", { zip_code: _self.comp_zip_search })
        .then(function (res) {
          let data = res.data.data;
          _self.comp_zip_items.push({ value: data.value, text: data.text });
          _self.form_data.comp_zip = data.value;
          _self.new_zip_id2 = data.value;
          _self.getStates(true);
          _self.loading = false;
        })
        .catch(function (error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    saveCustomer() {
      this.loading = true;
      this.form_error = {};
      let _self = this;
      let serverData = JSON.parse(JSON.stringify(this._data.form_data));
      // if (serverData.email && serverData.email_domain) {
      //   serverData.email = serverData.email + "@" + serverData.email_domain;
      // }
      axios
        .post("add_customer", serverData)
        .then(function (res) {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.form_error[key] = data.errors[key][0];
            }
          } else {
            _self.setData({ key: "add_modal", value: false });
          }
          _self.loading = false;
        })
        .catch(function (error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    closePopup() {
      this.setData({ key: "add_modal", value: false });
    },
    getCity(forCompany = false) {
      console.log("Tests : " + forCompany);
      let _self = this;
      let city_key = forCompany
        ? this.form_data.comp_state_id
        : this.form_data.state_id;
      axios
        .get("get_city?state_id=" + city_key)
        .then((response) => {
          if (response.data.status) {
            if (forCompany) {
              _self.company_cities = response.data.data;
            } else {
              _self.cities = response.data.data;
            }
          }
        })
        .catch(function () {});
    },
    changeCity() {
      if (this.form_data.zip == this.new_zip_id) {
        axios
          .post("zip_update", {
            state_id: this.form_data.state_id,
            zip_id: this.form_data.zip,
            city_id: this.form_data.city,
          })
          .then(() => {})
          .catch(function () {});
      }

      this.zip_loading = true;
      axios
      .get("get_zip_by_city?city_id=" + this.form_data.city)
      .then((response) => {
        if (response.data.status) {
          this.zip_items = response.data.data;
        }
      })
      .catch(function () {})
      .then(() => {
        this.zip_loading = false;
      });

    },
    changeCity2() {
      if (this.form_data.comp_zip == this.new_zip_id2) {
        axios
          .post("zip_update", {
            state_id: this.form_data.comp_state_id,
            zip_id: this.form_data.comp_zip,
            city_id: this.form_data.comp_city,
          })
          .then(() => {})
          .catch(function () {});
      }

      this.comp_zip_loading = true;
      axios
      .get("get_zip_by_city?city_id=" + this.form_data.comp_city)
      .then((response) => {
        if (response.data.status) {
          this.comp_zip_items = response.data.data;
        }
      })
      .catch(function () {})
      .then(() => {
        this.comp_zip_loading = false;
      });
    },
    getStates(forCompany = false) {
      let _self = this;
      let zip = forCompany ? this.form_data.comp_zip : this.form_data.zip;
      axios
        .get("get_states?zip=" + zip)
        .then((response) => {
          if (response.data.status) {
            _self.state_list = response.data.data;
            if (forCompany) {
              _self.company_cities = response.data.selection.all_city;
              _self.form_data.comp_state_id =
                response.data.selection.selected_state;
              _self.form_data.comp_city = response.data.selection.selected_city;
            } else {
              _self.cities = response.data.selection.all_city;
              _self.form_data.state_id = response.data.selection.selected_state;
              _self.form_data.city = response.data.selection.selected_city;
            }
          }
        })
        .catch(function () {});
    },
    getEmailDomains() {
      axios.get("get_domains").then((response) => {
        if (response.data.status) {
          this.domain_list = response.data.data;
        }
      });
    },
    fetchZipCodes() {
      this.zip_loading = true;
      axios
        .get("get_zip_suggestion?zip=" + this.zip_search)
        .then((response) => {
          console.log(response);
          if (response.data.status) {
            this.zip_items = response.data.data;
          }
        })
        .catch(function () {})
        .then(() => {
          console.log("k");
          this.zip_loading = false;
        });
    },
    fetchCZipCodes() {
      this.comp_zip_loading = true;
      axios
        .get("get_zip_suggestion?zip=" + this.comp_zip_search)
        .then((response) => {
          console.log(response);
          if (response.data.status) {
            this.comp_zip_items = response.data.data;
          }
        })
        .catch(function () {})
        .then(() => {
          console.log("ok");
          this.comp_zip_loading = false;
        });
    },
    getInitalStates(){
      let _self = this;
      axios
        .get("get_states")
        .then((response) => {
          if (response.data.status) {
            _self.state_list = response.data.data;
          }
        })
        .catch(function () {});
    }
  },
  mounted: function () {
    this.getEmailDomains();
    this.getInitalStates();
    this.getCity();
    this.getCity(true);
  },
};
</script>

<style>
</style>